import React from 'react';
import { Outlet } from 'react-router-dom';

const AttendantHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default AttendantHome;